import {Field, reduxForm} from 'redux-form'
import styles from './style.css'
import SettingField from 'components/Fields/ReduxForm/SettingField'

const validate = values => {
  const errors = {}
  if (!values.first_name) {
    errors.first_name = 'This field is required'
  }
  if (!values.last_name) {
    errors.last_name = 'This field is required'
  }

  if ((values.password) || (values.old_password) || (values.password_confirmation)) {
    if (!values.old_password) {
      errors.old_password = 'This field is required'
    }
    if (!values.password) {
      errors.password = 'This field is required'
    } else {
      if (values.password.length < 6) {
        errors.password = 'Please enter at least 6 characters'
      }
    }
    if (!values.password_confirmation) {
      errors.password_confirmation = 'This field is required'
    } else {
      if (values.password_confirmation !== values.password) {
        errors.password_confirmation = 'Password is not match'
      }
    }
  }
  return errors
}

class AccountForm extends React.Component {
  render () {
    let {handleSubmit} = this.props
    return (
      <form name='form' id='account-form' onSubmit={handleSubmit}>
        <fieldset>
          <div className='row'>
            <div className='col-lg-12'>
              <div className={styles['mk-sub-section-header']}>
                basic information
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-6 col-md-12 col-sm-6'>
              <div className='form-group'>
                <Field
                  component={SettingField}
                  type='text'
                  placeholder='First Name'
                  name='first_name'
                  maxLength='40'
                />
              </div>
            </div>
            <div className='col-lg-6 col-md-12 col-sm-6'>
              <div className='form-group'>
                <Field
                  component={SettingField}
                  type='text'
                  placeholder='Last Name'
                  name='last_name'
                  maxLength='40'
                />
              </div>
            </div>
          </div>
          <div className='row mb-20px'>
            <div className='col-lg-12'>
              <div className='form-group'>
                <Field
                  component={SettingField}
                  type='text'
                  placeholder='Email'
                  readOnly='true'
                  name='email'
                  maxLength='40'
                  dis
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className={styles['mk-divider-section-line']} />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className={styles['mk-sub-section-header']}>
                change password
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='form-group'>
                <Field
                  component={SettingField}
                  type='password'
                  placeholder='Current Password'
                  name='old_password'
                  maxLength='40'
                />
              </div>
            </div>
          </div>
          <div className='row mb-20px'>
            <div className='col-lg-6 col-md-12 col-sm-6'>
              <div className='form-group'>
                <Field
                  component={SettingField}
                  type='password'
                  placeholder='New Password'
                  id='new_password'
                  name='password'
                  maxLength='40'
                />
              </div>
            </div>
            <div className='col-lg-6 col-md-12 col-sm-6'>
              <div className='form-group'>
                <Field
                  component={SettingField}
                  type='password'
                  placeholder='Confirm New Password'
                  id='new_password_confirmation'
                  name='password_confirmation'
                  maxLength='40'
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className={styles['mk-divider-section-line']} />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <button
                type='submit'
                className='btn btn-primary pull-right'>
                Save
              </button>
            </div>
          </div>
        </fieldset>
      </form>
    )
  }
}

AccountForm.propTypes = {
  onSubmit: React.PropTypes.func,
  dispatch: React.PropTypes.func,
  data: React.PropTypes.object
}

export default reduxForm({
  form: 'accountForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate  // a unique identifier for this form
})(AccountForm)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Account/AccountForm.js